<script>
import { new_api } from "../auth_config.json";
// import HowTo from '@/LearnMore/HowTo.vue';
// import Blog from '@/Blogs/blogListing.vue';
// import ClickOutside from 'vue-click-outside'

// import SidebarComp from "@/Sidebar/Sidebar.vue";
import ReportAssesment from "@/ReportAssesments/index.vue";
export default {
  name: "nav-bar",
  components: {
    // HowTo, Blog
    // ClickOutside
    // SidebarComp,
    ReportAssesment
  },

  props: {
    showPeer: {
      type: Boolean,
      required: true
    },
    showResult: {
      type: Boolean,
      required: true
    },
    stepEnable: {
      type: Boolean,
      required: true
    },
    dataLoading: {
      type: Boolean,
      required: true
    }
  },
  watch: {
    dataLoading: {
      handler(value) {
        this.reportLoading = value;
      },
      deep: true
    },
    stepEnable: {
      handler(value) {
        if (this.activateTab != 3) {
          if (value) {
            this.activateTab = 1;
          } else {
            this.activateTab = 2;
          }
        }
      },
      deep: true
    }
  },
  data() {
    let token;
    try {
      var cookieArr = document.cookie.split(";");

      // Loop through the array elements
      for (var i = 0; i < cookieArr.length; i++) {
        var cookiePair = cookieArr[i].split("=");

        /* Removing whitespace at the beginning of the cookie name
        and compare it with the given string */
        if ("userDetail" == cookiePair[0].trim()) {
          // Decode the cookie value and return
          console.log(decodeURIComponent(cookiePair[1]));
          token = decodeURIComponent(cookiePair[1]);
        }
      }
    } catch (e) {}

    return {
      old_password: "",
      new_password: "",
      access_token: token,
      peer: this.showPeer,
      isSticky: false,
      stickyClass: "is_sticky",
      scrollPosition: 0,
      checked: true,
      opened: false,
      modalShow: false,
      data: null,
      buttonOpen: false,
      reportClick: false,
      activateTab: 1,
      reportLoading: true
    };
  },
  created() {
    try {
      this.checked =
        localStorage.getItem("mode") === null
          ? false
          : localStorage.getItem("mode") === "false"
          ? false
          : true;
    } catch (e) {
      this.checked = true;
    }

    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  async mounted() {
    if (this.$route.query.report) {
      this.activateTab = 3;
      this.reportClick = true;
      this.$bvModal.show("modal-fullscreen");
      this.$router.replace({ query: null });
    }
    if (this.$route.query.onboard) {
      this.activateTab = 1;
    }
    if (this.$route.query.mainapp) {
      this.activateTab = 2;
      this.onByPass();
      this.$router.replace({ query: null });
    }
    const storedData = await localStorage.getItem("storedData");
    if (storedData) {
      if (storedData.age && this.activateTab === 1) {
        this.activateTab = 2;
      }
    }

    window.addEventListener("loginEvent", event => {
      this.data = event.detail;
    });

    const hash = new URL(window.location.href).hash;
    if (hash && hash.includes("#access_token=")) {
      const token = hash.split("#access_token=")[1];
      try {
        localStorage.setItem("access_token", token);
      } catch (e) {}
      this.access_token = token;
      this.$parent.access_token = token;
      history.replaceState({}, document.title, ".");
    }
    // var hash = window.location.href;
    // console.log(hash,'sasaaa')
    // prevent click outside event with popupItem.
    this.popupItem = this.$el;
  },
  // do not forget this section
  directives: {
    // ClickOutside
  },
  computed: {
    userName() {
      return (
        (this.$cookies.get("userDetail") && this.$cookies.get("userDetail").data
          ? this.$cookies.get("userDetail").data.name
          : null) || this.data
      );
    },
    userId() {
      return (
        (this.$cookies.get("userDetail") && this.$cookies.get("userDetail").data
          ? this.$cookies.get("userDetail").data.id
          : null) || this.data
      );
    },
    getUserId() {
      return (
        (this.$cookies.get("userDetail") && this.$cookies.get("userDetail").data
          ? this.$cookies.get("userDetail").data.id
          : null) || this.data
      );
    },
    userType() {
      return (
        (this.$cookies.get("userDetail") && this.$cookies.get("userDetail").data
          ? this.$cookies.get("userDetail").data.user_type
          : null) || this.data
      );
    },
    userEmail() {
      return (
        (this.$cookies.get("userDetail") && this.$cookies.get("userDetail").data
          ? this.$cookies.get("userDetail").data.email
          : null) || this.data
      );
    },
    getCookies() {
      return (
        (this.$cookies.get("userDetail") &&
          this.$cookies.get("userDetail").data) ||
        this.$cookies.get("userDetail")
      );
    }
  },
  methods: {
    openSpendidApp() {
      this.outSideClickClose();
      this.onByPass();
      if (this.activateTab !== 2) {
        this.activateTab = 2;
      }
    },
    reportPerticularClick() {
      this.reportClick = true;
      setTimeout(() => {
        this.$bvModal.show("modal-fullscreen");
      }, 10);
    },
    outSideClickClose() {
      if (this.reportClick) {
        this.$bvModal.hide("modal-fullscreen");
      }
    },
    onByPass() {
      let headers = {
        Authorization: "Bearer " + this.getCookies.access_token
      };
      this.$http
        .post(
          `${new_api}/report-save`,
          {
            name: "new Report"
          },
          { headers }
        )
        .then(
          res => {
            this.$cookies.set("assessmentId", res.data.reportId);

            this.$http
              .get(`${new_api}/get-last-data-By-user`, { headers })
              .then(response => {
                this.$emit("fillAutoData", response);
                // location.reload()
              });

            // this.$emit('stepEnable', false)
          },
          response => {
            if (response.status == 401) {
              this.$cookies.remove("userDetail");
              localStorage.removeItem("storedData");
            }
          }
        );
    },
    changeNow() {
      const user = this.getCookies;
      let headers = {
        Authorization: "Bearer " + this.getCookies.access_token
      };
      this.$http
        .post(
          `${new_api}/change-password`,
          {
            old_password: this.old_password,
            new_password: this.new_password,
            userId: user.id
          },
          { headers }
        )
        .then(res => {
          this.old_password = "";
          this.new_password = "";
          this.$bvModal.hide("change-popup");
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    btnClick() {
      window.open("https://mybudgetreport.com/free-demo");
    },
    logoutAll() {
      this.$cookies.remove("userDetail");
      localStorage.removeItem("access_token");
      localStorage.removeItem("storedData");
      this.$cookies.remove("assessmentId");
      window.location.href = "https://spendid.io";
      // this.$parent.resetDefault(false)
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    cancel() {
      this.$refs["startover"].hide();
    },
    toggle() {
      this.opened = !this.opened;
    },
    hide() {
      this.opened = false;
    },
    activeTabs(arg) {
      this.$parent[arg] = false;
      this.$parent.validateCheck();
      this.$parent.checkResultToggle();
    },
    handleScroll() {
      this.scrollPosition = window.scrollY;
      if (this.scrollPosition >= 1) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    },
    login() {
      this.$auth.loginWithPop();
    },
    // Log the user out
    logout() {
      localStorage.removeItem("access_token");
      location.reload();
      //   this.$auth.logout({
      //     returnTo: window.location.origin
      // });
    }
  }
};
</script>

<style scoped>
.navbar-custom {
  /* font-size: 2rem; */
  font-weight: 700;
  background: #fff;
  box-shadow: 0 0 21px rgb(0 0 0 / 20%);
  position: fixed;
  z-index: 9;
  padding: 10px;
  /* -webkit-transition: all 0.4s ease;
  transition: all 0.4s ease; */
  top: 0;
  left: 0;
  right: 0;
}

.logo-navbar {
  display: flex;
  line-height: inherit;
}
.navbar-logo a img,
.navbar-logo img,
.navbar-logo-customer img,
.navbar-logo-customer a img {
  max-height: 110px;
}
.navbar-logo-customer {
  position: absolute;
  left: 0;
  right: 0;
  width: 240px;
}
.navbar-brand.navbar-logo.margin-left {
  min-height: 90px;
  margin-left: 0px;
}
.brand-tagline .navbar-text {
  color: #000;
  font-size: 18px;
  font-weight: 600;
  line-height: inherit;
  padding: 0;
}
.brand-tagline .powered-by {
  font-size: 14px;
  font-weight: normal;
  font-style: italic;
  line-height: inherit;
  text-align: right;
}
.brand-tagline .powered-by span {
  font-weight: 600;
  text-transform: uppercase;
  color: #225935;
  line-height: inherit;
}
.navbar-custom.isSticky {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
  width: 100%;
  /* width: calc(100% - 320px); */
  -webkit-transition: all 0.4s ease;
  transition: all 0.4s ease;

  /* -webkit-animation: .95s ease-in-out 0s normal none 1 running fadeInDown;
  animation: .95s ease-in-out 0s normal none 1 running fadeInDown;
  -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1); */
}

/* .nav-action-btns .btn{
  width: 96px;
} */

.nav-action-btns .btn.btn-success {
  background-color: #225935;
  border: solid 2px #225935;
  font-weight: 600;
  border-radius: 6px;
}
.btn-success:not(:disabled):not(.disabled):active:focus,
.btn-success:not(:disabled):not(.disabled):active {
  background-color: transparent;
  box-shadow: none;
}
.nav-action-btns .btn.btn-success:hover,
.nav-action-btns .btn.btn-success:focus,
.btn-success:not(:disabled):not(.disabled):active:focus {
  border: solid 2px #555;
  color: #fff;
  background-color: #555;
  box-shadow: none;
}
.dark-logo {
  display: none;
}
.darkmode .navbar-custom,
.darkmode .navbar-light,
.darkmode .navbar {
  background: #1e2041 !important;
}
.darkmode .navbar-custom .light-logo,
.darkmode .navbar-light .light-logo,
.darkmode .navbar .light-logo {
  display: none;
}
.darkmode .navbar-custom .dark-logo,
.darkmode .navbar-light .dark-logo,
.darkmode .navbar .dark-logo {
  display: block;
}
.darkmode .navbar .nav-action-btns {
  color: #ffffff !important;
}
.darkmode .navbar-custom .navbar-logo-customer.bg-light,
.darkmode .navbar-light .navbar-logo-customer.bg-light,
.darkmode .navbar .navbar-logo-customer.bg-light {
  background-color: #383b65 !important;
  border-color: #383b65 !important;
}
.darkmode .navbar-custom .navbar-logo-customer.bg-light h4,
.darkmode .navbar-light .navbar-logo-customer.bg-light h4,
.darkmode .navbar .navbar-logo-customer.bg-light h4 {
  color: #fff;
}
.darkmode .navbar-custom.isSticky {
  background-color: #000000 !important;
  border-color: #000000 !important;
  top: 0px;
  /* transform: translateY(24px);
  transition: transform .4s; */
}
/* .darkmode .theme-change-mode {
    background: #1E2041 !important;
} */

.darkmode .theme-change-mode,
.theme-change-mode {
  padding: 1px;
  position: absolute;
  right: 15px;
  top: 10px;
}
.nav-action-btns .acount-profile-wrap {
  position: absolute;
  right: 30px;
  top: -3px;
  font-size: 14px;
}
.nav-action-btns .acount-profile-wrap a.profile_icon img {
  height: 35px;
  width: 35px;
  background: #eaeff6;
  border-radius: 100%;
}
.nav-action-btns .acount-profile-wrap a.profile_icon p {
  font-size: 14px;
  text-transform: capitalize;
}
.nav-divider {
  background-color: #444;
  width: 2px;
  margin: 0 8px;
  height: 32px;
}
.darkmode .nav-divider {
  background-color: #fff;
}
.results-btn-mobile {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 9;
  text-align: center;
  display: block;
  width: 100%;
  padding: 20px 0;
  background-color: #2b2f5e;
  box-shadow: 0 0 26px rgb(0 0 0 / 40%);
}
/* .results-btn-mobile .btn.btn-theme {
  display: block;
  width: 100%;
  padding: 16px 0;
  font-size: 20px;
  border-radius: 0!important;
  text-transform: uppercase;
} */
.results-btn-mobile .btn.btn-theme:hover,
.results-btn-mobile .btn.btn-theme:focus {
  /* border: 0!important; */
  box-shadow: none !important;
}

@media all and (min-width: 768px) and (max-width: 991px) {
  /* .darkmode .theme-change-mode, .theme-change-mode {
    padding: 1px;
    position: relative;
    right: 8px;
    top: 8px;
  } */
}

@media all and (max-width: 1199px) {
  .darkmode .theme-change-mode,
  .theme-change-mode {
    right: 0px;
  }
  .navbar-brand.navbar-logo.margin-left {
    margin-left: 0px;
    min-height: auto;
  }
}

@media screen and (max-width: 1024px) {
  /* .nav-divider{
      display: none;
    } */
  .navbar-logo a img,
  .navbar-logo img,
  .navbar-logo-customer img,
  .navbar-logo-customer a img {
    max-height: 50px;
  }
  /* .navbar-logo.customer-logo {
    width: 96%;
  } */
  .navbar-custom .navbar-toggler {
    background-color: #180f4f;
  }
  .customer-logo {
    /* border: solid 1px #ddd; */
    background-color: #fff;
    /* padding: 6px 0; */
    border-radius: 4px;
  }
  .collapse-nav {
    /* background-color: #eee;
    border: solid 1px #ddd; */
    border-radius: 0px;
  }
  /* .darkmode .collapse-nav{
    background-color: #383B65!important;
    border: solid 1px #383B65!important;
  } */
  /* .darkmode .nav-action-btns{
    border-top: solid 1px #383B65;
  } */
  /* .darkmode .customer-logo, .darkmode .customer-logo .bg-light,
  .darkmode .collapse-nav{
    background-color: #383B65!important;
    border: solid 1px #383B65!important;
  } */
  .darkmode .customer-logo .bg-light {
    color: #fff;
  }
}
@media screen and (max-width: 991px) {
  .navbar-brand.navbar-logo.margin-left[data-v-2bb78d39] {
    width: 290px;
  }

  .theme-change-mode.d-lg-block {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .theme-change-mode .d-lg-inline-block.custom-control.custom-switch {
    margin-right: 10px;
  }
  .nav-action .nav-action-btns .custom-switch {
    margin-left: 1.25rem;
  }
  .custom-switch {
    margin-left: 1.25rem;
    padding-left: 14px;
    position: relative;
    z-index: 999;
  }
}
@media screen and (max-width: 767px) {
  .nav-divider {
    display: none;
  }
  .navbar-custom {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 99;
  }
  .switch-mobile-view label {
    font-size: 13px;
    position: relative;
    top: 2px;
  }

  .navbar-custom {
    padding: 0px 10px;
  }
  /* .navbar-logo.customer-logo {
    width: 100%;
  } */
  .brand-tagline .navbar-text {
    font-size: 16px;
    vertical-align: middle;
    line-height: 2;
  }
  .navbar-logo a img,
  .navbar-logo img,
  .navbar-logo-customer img,
  .navbar-logo-customer a img {
    max-height: 56px;
    max-width: 100%;
  }
  .nav-action-btns .btn {
    font-size: 0.705rem;
  }
}

@media only screen and (device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) {
  .navbar-logo a img,
  .navbar-logo img,
  .navbar-logo-customer img,
  .navbar-logo-customer a img {
    max-height: 54px;
  }
}
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  .navbar-logo a img,
  .navbar-logo img,
  .navbar-logo-customer img,
  .navbar-logo-customer a img {
    max-height: 52px;
  }
}
@media only screen and (device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 3) {
  .navbar-logo a img,
  .navbar-logo img,
  .navbar-logo-customer img,
  .navbar-logo-customer a img {
    max-height: 42px;
  }
}
@media screen and (max-width: 375px) {
  .navbar-logo a img,
  .navbar-logo img,
  .navbar-logo-customer img,
  .navbar-logo-customer a img {
    max-height: 48px;
  }
}
@media screen and (max-width: 374px) {
  .navbar-logo a img,
  .navbar-logo img,
  .navbar-logo-customer img,
  .navbar-logo-customer a img {
    max-height: 42px;
  }
}

/* Vertical Sidenav */
.vertical-sidenav ul li a {
  color: #180f4f;
  border: solid 1px #e1e1e1;
  margin-bottom: 10px;
  border-radius: 4px;
}
.logot-button .btn.btn-success,
.logout-action .btn.btn-success {
  background-color: #68aca5;
  border: solid 2px #68aca5;
  font-weight: 600;
  border-radius: 6px;
}
.logot-alerts-slide .card {
  background-color: transparent;
  box-shadow: none;
}
.logout-info h5 {
  color: #180f4f;
}
.logout-info p {
  color: #343a40;
}
.darkmode .navbar-custom.default-dark {
  background: #0a0b0c !important;
}
.navbar-custom.default-dark .theme-change-mode label.custom-control-label {
  color: #0a0b0c !important;
}
.darkmode
  .navbar-custom.default-dark
  .theme-change-mode
  label.custom-control-label {
  color: #fff !important;
}
.user-detail img {
  width: 90px;
  height: 90px;
  border-radius: 100%;
  margin: 0 auto 12px;
  position: relative;
  left: 50%;
  transform: translate(-50%, 0);
}
.user-detail p {
  text-align: center;
  color: #000;
}
.darkmode .user-detail p {
  color: #fff;
}
.text-teal {
  color: rgb(64, 155, 146);
}
@media only screen and (min-width: 1025px) {
  .customer-logo {
    position: absolute;
    display: inline-block;
    left: 50%;
    right: 0;
    transform: translate(-50%, 0px);
  }
  .customer-logo img {
    /* padding: 6px; */
    background-color: #fff;
    border-radius: 10px;
  }
  .navbar-logo a img,
  .navbar-logo img,
  .navbar-logo-customer img,
  .navbar-logo-customer a img {
    max-height: 140px;
  }
}

@media only screen and (max-width: 767px) {
  .customer-logo {
    position: inherit;
    transform: none;
    left: 10px;
    right: auto;
  }
  .customer-logo img {
    max-height: 48px;
  }
}
</style>

<template>
  <div>
    <div class="position-relative zIndex1">
      <b-navbar
        class="navbar-custom default-dark"
        id="navbar"
        :class="{ isSticky: isSticky }"
        type="light"
      >
        <div class="navbar-brand navbar-logo d-none d-md-block py-0">
          <a href="#">
            <img
              alt="logo"
              src="spendid-logo.png"
              class="dark-logo d-block"
            />
          </a>
        </div>
        <div class="navbar-logo customer-logo text-center mx-auto">
          <img alt="logo" src="brown-logo.png" />
        </div>
        <b-container fluid>
          <div class="collapse-nav ml-auto">
            <div
              class="nav-action d-md-flex align-items-center justify-content-end py-2"
            >
              <div class="nav-action-btns d-flex justify-content-end">
                <div
                  class="theme-switch text-md-center text-center mb-md-0 mb-2"
                >
                  <b-form-checkbox
                    size="sm"
                    class="mr-2 d-none"
                    @change="$parent.changeMode($event)"
                    v-model="checked"
                    name="check-button"
                    switch
                  >
                    Light/Dark
                  </b-form-checkbox>
                </div>
                <div
                  class="action-btns d-flex align-items-center justify-content-center"
                >
                  <b-button
                    title="Home"
                    @click="$parent.resetDefault(true)"
                    variant="success"
                    size="sm"
                    class="mr-2"
                  >
                    <span class="d-none d-md-inline-block">Profile</span>
                    Interview
                  </b-button>
                  <b-button
                    title="Clear Inputs"
                    v-b-modal.startover
                    v-scroll-to="{ el: '#navbar', offset: -170 }"
                    variant="success"
                    size="sm"
                    class=" d-lg-block mr-2"
                  >
                    Clear Inputs
                  </b-button>
                  <!-- <div class="nav-divider"></div>
            <b-button title="How To" @click="$parent.changePage('how')" v-scroll-to="{ el: '#navbar', offset: -170 }" class="btn btn-sm btn-success "> How To </b-button>
             -->
                  <div class="nav-divider"></div>
                  <div
                    class="d-flex ml-2 ml-md-0 switch-mobile-view"
                    onClick="bodyClassAdd()"
                  >
                    <label
                      class="mb-0 mr-2 d-block d-md-none"
                      for="darkLightChange"
                    >
                      Light/Dark
                    </label>
                    <b-form-checkbox
                      class="ml-lg-2 d-lg-inline-block"
                      id="darkLightChange"
                      @change="$parent.changeMode($event)"
                      v-model="checked"
                      name="check-button"
                      switch
                    >
                      <!-- Light/Dark -->
                    </b-form-checkbox>
                    <label class="mb-0 d-none d-md-block" for="darkLightChange">
                      Light/Dark
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- </div> -->
          <!-- </b-collapse> -->
          <div class="nav-action-btns w-100 text-center py-2  d-none">
            <div
              class="d-flex align-items-center justify-content-between justify-content-lg-between"
            >
              <b-form-checkbox
                size="sm"
                class="mr-lg-4 d-lg-inline-block font-weight-normal"
                v-model="peer"
                @change="$parent.changePeer($event)"
                switch
                >Show Peer Data?</b-form-checkbox
              >
              <div class="">
                <!-- <b-button title="Results" @click="activeTabs('visibleCashHealthAnalysis')" v-scroll-to="{ el: '#cash-flow-score', offset: -190 }" variant="success" size="sm" class="mr-2">
          Results
        </b-button> -->
                <b-button
                  title="Home"
                  @click="$parent.resetDefault(true)"
                  variant="success"
                  size="sm"
                  class="mr-2"
                >
                  Home
                </b-button>
                <b-button
                  title="Clear Inputs"
                  v-b-modal.startover
                  v-scroll-to="{ el: '#navbar', offset: -170 }"
                  variant="success"
                  size="sm"
                  class="d-lg-none"
                >
                  Clear Inputs
                </b-button>
              </div>
            </div>
          </div>
        </b-container>
      </b-navbar>
    </div>
    <div v-if="showResult" class="results-btn-mobile d-none d-lg-none">
      <b-button
        title="Results"
        @click="activeTabs('visibleCashHealthAnalysis')"
        v-scroll-to="{ el: '#cash-flow-score', offset: -100 }"
        variant="success"
        class="btn-theme btn-sm"
      >
        See Results
      </b-button>
    </div>

    <b-modal
      id="startover"
      size="small"
      ref="startover"
      hide-footer
      hide-header
      title="Clear All Field Data"
    >
      <div class="mb-4 d-block text-center">
        <i class="fas fa-exclamation-circle text-warning fa-5x"></i>
      </div>
      <div class="my-4 d-block text-center">
        <h3 class="font-weight-bold">Are you sure?</h3>
        <p>You want to <b>Clear</b> all input data fields</p>
      </div>
      <div class="my-4 d-block text-center">
        <b-button variant="secondary" @click="cancel()" class="mx-1">
          Cancel
        </b-button>
        <b-button
          type="button"
          @click="$parent.resetDefault(false)"
          variant="success"
          class="btn-theme mx-1"
          >Clear All</b-button
        >
      </div>
    </b-modal>
    <!-- custom_blocks end-->
  </div>
</template>
